import { MenuItem } from '@usimweb/core/models';

export abstract class Menu {
  // public static menuItems: MenuItem[] = [
  //   { icon: 'show_chart', text: 'Analyze', item: 'analyze', toolTip: 'Analyze simulation...', type: 'button' },
  //   { icon: 'refresh', text: 'Restart', item: 'restart', toolTip: 'Restart simulation...', type: 'button' },
  //   { icon: 'refresh', text: 'Refresh', item: 'refresh', toolTip: 'Refresh results...', type: 'button' },
  //   { icon: 'content_copy', text: 'Clone', item: 'clone', toolTip: 'Clone simulation...', type: 'button' },
  //   { icon: 'delete', text: 'Delete', item: 'delete', toolTip: 'Delete simulation...', type: 'button' },
  // ];

  public static menuItems: MenuItem[] = [
    { icon: 'refresh', text: 'Restart', item: 'restart', toolTip: 'Restart simulation...', type: 'button' },
    { icon: 'edit', text: 'Rename', item: 'rename', toolTip: 'Rename simulation...', type: 'button' },
    { icon: 'content_copy', text: 'Clone', item: 'clone', toolTip: 'Clone simulation...', type: 'button' },
    { icon: 'delete', text: 'Delete', item: 'delete', toolTip: 'Delete simulation...', type: 'button' },
  ];

  public static getMenu(app: string) {
    if (app === 'vela') {
      this.menuItems.map((x) => {
        if (x.item === 'clone') {
          x.item = 'copy';
          x.text = 'Copy to';
          x.toolTip = 'Copy simulation to...';
        }
      });
    }
    return this.menuItems;
  }
}
